<script>
export let resource;


let types = {
	'article': 'Article',
	'video': 'Video',
	'pdf': 'PDF',
}

let type = types[resource.resource_type];


import { Navigate } from 'svelte-router-spa';

</script>


<style>

:global(.resource-thumb) {
	display: block;
	height: 100%;
}


.card-image {
	background: linear-gradient(rgb(0 0 0 / 70%), rgb(0 0 0 / 70%)), url(https://res.cloudinary.com/df7hgjaql/image/upload/v1618083656/rinky_t8iczd.jpg) !important;
	background-size: cover !important;
	background-position: center !important;
}

.resource-image {
	/*padding-top: 40%;*/
	border-top-left-radius: 2px;
	border-top-right-radius: 2px;
}


.resource-image.with-icon {
	/*background: var(--bg-grey);*/
	text-align: center;
	padding-top: 4.5rem;
	padding-bottom: 4.5rem;
	/*background: #454a4e !important;*/
}


/*.resource-image.with-icon.video {
	background: #a02429;
}

.resource-image.with-icon.article {
	background: #6746b1;
}

.resource-image.with-icon.pdf {
	background: #317a8c;
}
*/


.resource-image.with-icon i {
	font-size: 4rem;
	color: var(--text-white);
}


.resource-image.with-image {
	padding-top: 6.5rem;
	padding-bottom: 6.5rem;
}


.card-content {
	padding: 1rem 1rem !important;
	padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
}

.resource-title {
	font-size: 1.275rem;
	color: #1f1f1f;
}

.resource-type {
	text-decoration: underline;
}


.resource-info {
	margin-top: 0.5rem;
	font-size: 1.075rem;
	color: #3c3c3c;
	/*margin-bottom: 0.75rem;*/
}



/* font */

</style>

<!-- Navigate to...? for ALL l -->

{#if resource.resource_type === 'pdf'}

<!-- <Navigate styles="resource-thumb card" to="/my/resource/{resource.resource_type}/{resource.slug}"> -->
<a href="{resource.pdf_link}" class="card resource-thumb" target="_blank">

	<div class="card-image">

		{#if resource.thumbnail_image_url}

		<figure class="image resource-image with-image" style="background-image: url({resource.thumbnail_image_url});"></figure>

		{:else}

		<figure class="image resource-image with-icon {resource.resource_type}">
			{#if resource.resource_type === 'video'}
				<i class="fal fa-video"></i>
			{:else if resource.resource_type === 'article'}
				<i class="fal fa-newspaper"></i>
			{:else if resource.resource_type === 'pdf'}
				<i class="fal fa-file-pdf"></i>
			{/if}
		</figure>

		{/if}


	</div>

	<div class="card-content">

		<p class="resource-title">
			<span class="resource-type">{type}</span>: {resource.name}
		</p>

	</div>

</a>

{:else}

<Navigate styles="resource-thumb card" to="/my/resource/{resource.resource_type}/{resource.slug}">

	<div class="card-image">

		{#if resource.thumbnail_image_url}

		<figure class="image resource-image with-image" style="background-image: url({resource.thumbnail_image_url});"></figure>

		{:else}

		<figure class="image resource-image with-icon {resource.resource_type}">
			{#if resource.resource_type === 'video'}
				<i class="fal fa-video"></i>
			{:else if resource.resource_type === 'article'}
				<i class="fal fa-newspaper"></i>
			{:else if resource.resource_type === 'pdf'}
				<i class="fal fa-file-pdf"></i>
			{/if}
		</figure>

		{/if}


	</div>

	<div class="card-content">

		<p class="resource-title">
			<span class="resource-type">{type}</span>: {resource.name}
		</p>

	</div>

</Navigate>

{/if}



